import { DateYmd } from 'hydra-data-types';
import moment from 'moment';
import React, { ReactElement } from 'react';
import { stripUndefined } from 'ts-utils';
import { LayoutScreenConfig, ScreenType, SharedScreenName } from '../../config/FlowTypes';
import { dispatchUserData } from '../../store/userData/UserDataActions';
import { Analytics } from '../../util/Analytics';
import { NavigationProps } from './FlowNavigation';
import { DateOfBirthLayout, DateOfBirthLayoutConfig } from './layouts/DateOfBirthLayout';

export type DateOfBirthScreenConfig<ScreenNames extends string> = LayoutScreenConfig<
  ScreenType.DateOfBirth,
  DateOfBirthLayoutConfig,
  ScreenNames
>;

type Props<ScreenNames extends string> = NavigationProps<
  DateOfBirthScreenConfig<ScreenNames>,
  ScreenNames
>;

export const DateOfBirthScreen = <ScreenNames extends string>(
  props: Props<ScreenNames>
): ReactElement => {
  function onSubmitPress(value: DateYmd): void {
    const { screenName, navigation } = props;

    dispatchUserData({ [screenName]: [value] });
    // DOB is always PII so no `answer` value is included in analytics event
    Analytics.track({
      event: Analytics.Event.o_question_answered,
      ...stripUndefined({ question: screenName }),
    });

    // If screen is patient date of birth, compute and dispatch the age, as age is needed for Segment Traits.
    if (screenName === SharedScreenName.DateOfBirth) {
      const age = moment().diff(moment(value, 'yyyy-MM-DD'), 'years');
      dispatchUserData({ age: [age.toString()] });
    }

    navigation.next(props);
  }

  return (
    <DateOfBirthLayout
      {...props.layout}
      onPressPrimaryButton={onSubmitPress}
      primaryButtonTitle="Next"
    />
  );
};
